<script>
export default {
  name: 'notifcations'
}
</script>

<template lang="pug">
    li.notif
        | 
        span.notification
        .notif-drop
            .title
            span.icon 
            h4 Notificações
            .item
            span.icon.alert 
            |  Atualize sua Foto de Perfil
            small 1 hora
            .item
            span.icon.alert 
            |  Cadastre um Endereço de Correspondência
            small 2 dias atrás
            .item
            span.icon.alert 
            |  Valide seu Número  de Celular
            small 1 mês atrás
            .divider
            .title
            span.icon 
            h4 Próximos Eventos Agendados
            .item
            span.icon.agenda 
            | 08:00 - 25/03 - Maria da Silva (Agendado)
            small
                | Dr. Igor Popadiuk (Clínica Médica)
                br
                |                 Rua Buenos Aires, 441 - Batel - Curitiba - PR
            .item
            span.icon.agenda 
            | 14:20 - 2531/03 - Lucas Pereira da Silva (Transferido)
            small
                | Dra. Célia Mendes (Dermatologista)
                br
                |                 Praça Rui Barbosa, 441 - Centro - Curitiba - PR
            .divider
            button
                router-link(:to="{name: 'patient.notifications.index'}")
                    span.icon 
                    |  Ver Todas as Notificações

</template>



// WEBPACK FOOTER //
// src/layout/headers/notifications.vue